export default __webpack_public_path__ + "static/media/pngtree.4851a887.svg";